import BaseApi from './base'

class LogMail extends BaseApi {
  getLogMails = (query) => this.client.get(`admin/log-mail?${query}`)
}
export default new LogMail()
